// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "33d91445" + "." + "18d2861874402c17" + ".js";
};